module.exports = __webpack_public_path__ + "static/media/CheckBox.2b4d7704.svg";